import { clsx } from "clsx";

export const ItemLayout = ({
  badgeRight,
  badgeLeft,
  className,
  children,
  ...rest
}: JSX.IntrinsicElements["button"] & {
  badgeRight?: React.ReactNode;
  badgeLeft?: React.ReactNode;
}) => (
  <div className="relative">
    {badgeRight ? (
      <div className="absolute -right-2 -top-2 z-10 ">{badgeRight}</div>
    ) : null}
    {badgeLeft ? (
      <div className="absolute -left-1 -top-2 z-10 ">{badgeLeft}</div>
    ) : null}
    <button
      className={clsx(
        "min-h-[130px] w-full rounded-md outline-none",
        rest.disabled && "cursor-not-allowed opacity-50",
        className
      )}
      style={{ minHeight: "130px" }}
      type="button"
      {...rest}
    >
      {children}
    </button>
  </div>
);
